import React, { useMemo } from 'react';
import moment from 'moment';

import StyleSampleList from './StyleSampleList';
import { classNamesFromStatus } from 'components/VirtualAtelier/StyleSummary/StyleSummary';
import IconFolder from 'assets/icons/Icon-folder.svg';

const headerGroups = [
  {
    header: '',
  },
  {
    header: 'Name',
  },
  {
    header: 'Uploaded Date',
  },
  {
    header: 'Metadata',
  },
];

const StyleSampleListView = ({ media, editTileOptions, updatePositionsHandler, onClickRow, ...props }) => {
  const cellData = useMemo(
    () =>
      media?.map(reference => {
        const { status, type } = reference;
        return {
          key: reference?.key,
          col: [
            {
              imageUrl: reference.assetUrl,
              icon: type === 'folder' ? IconFolder : undefined,
            },
            {
              cell: reference?.name || 'Name',
            },
            {
              cell:
                moment.unix(reference.modified).format('DD MMM ha') || 'Uploaded Date',
            },
            {
              cell: <button className={classNamesFromStatus(status)}>{status}</button>,
            },
          ],
          data: reference,
          position: reference?.position
        };
      }),
    [media]
  );

  return (
    <StyleSampleList
      headerGroups={headerGroups}
      showHeader={false}
      cellData={cellData}
      popUpOptions={editTileOptions}
      updatePositionsHandler={updatePositionsHandler}
      onClickRow={onClickRow}
      {...props}
    />
  );
};

export default StyleSampleListView;
